import { observable, action, computed, createTransformer, reaction, extendObservable } from "mobx";
import SolicitacaoService from "../../../services/SolicitacaoService";
import {toast} from "react-toastify";
import axios from "axios/index";

export default class RascunhosStore {

    @observable rascunhosLista;
    @observable loading;
    @observable selecaoTemp;
    @observable selecionados;
    @observable modalOpen;

    constructor() {
        this.rascunhosLista = [];
        this.solicitacaoService = new SolicitacaoService();
        this.selecionados = []
        this.modalOpen = false;
    }

    carregarLista() {
        this.loading = true;

        const loadingPromises = Promise.all([
            this.solicitacaoService.listRascunhos().then(response => {
                this.rascunhosLista = response.data;
            }).catch(error => {
                console.log(error);
            })
        ]);
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        );
    }

    setLista(value) {
        this.rascunhosLista = value;
    }

    abrirModal(selecionados){
        this.selecaoTemp = selecionados
        this.modalOpen = true;
    }

    fecharModal(){
        this.modalOpen = false;
    }

    removerSelecionados() {
        /*O ideal seria limpar array de itens selecionados após a exclusão*/
        let selecaoFormat = this.verificarSelecao(this.selecaoTemp);

        this.solicitacaoService.excluirRascunho({ ids: selecaoFormat })
            .then(() => {
                this.selecaoTemp.map( (itemSelecionado) => {
                        let tabelaIndex = this.rascunhosLista.findIndex((tabelaItem) => tabelaItem.id === itemSelecionado);
                        if(tabelaIndex>-1) this.rascunhosLista.splice(tabelaIndex, 1);
                });
                this.modalOpen = false;
                toast.success(`Rascunho(s) excluído(s) com sucesso`);
            })
            .catch((error) => {
                if(axios.isCancel(error)) {
                    console.log(`Operação de excluir rascunho(s) cancelada.`);
                } else {
                    console.log(`Erro ao excluir rascunho(s)`);
                }
                this.modalOpen = false;
            })
    }

    verificarSelecao(selecao){
        let novosSelecionados = selecao.filter(val => !this.selecionados.includes(val));
        this.selecionados = selecao;
        return novosSelecionados;
    }

}